import {filterRulesMapped} from '@/tools/filterRules'
import { gpsService } from '@/services/gps.service'
import { mapState } from 'vuex'

export default {
    name: 'GpsHistoryComponent',
    components: {
    },
    data: () => ({
        tableHeaders: [],
        tableFilterRules: {},
        tableData: [],
        tableDataKey: 'timestamp',
        tableComponentButtons: [],
        loadingTable: true,
        queryId: undefined,
    }),
    computed: {
        /*
            TO DO: cambiar por getters
        */
        ...mapState('reportBreadcrumb', {
            entitySelectorItems: state => state.entitySelectorItems,
            selectedItem: state => state.selectedItem,
            entitySelectorConfiguration: state => state.entitySelectorConfiguration
        }),
    },
    created () {
        // id
        if (this.selectedItem) {
            this.queryId = this.selectedItem.id;
        }
    },
    mounted () {
        // Obtener el historial de vinculaciones
        this.getData()
    },
    methods: {
        /**
         * Refrescar la data
         */
        async refreshTable () {
            if (this.selectedItem) {
                this.queryId = this.selectedItem.id;
                await this.getData(true)
            }
        },
        /**
         * Datos
         * @param {*} update
         */
        async getData (update = false) {
            this.loadingTable = true
            gpsService.getHistory(this.queryId, !update).then(response => {
                this.tableData.cleanAndUpdate(response.data)
                if (!update) {
                    this.tableHeaders.cleanAndUpdate(response.headers)
                    this.setTableFilterRules()
                }
                this.loadingTable = false
            })
        },
        /**
         * Reglas de filtrado
         */
        setTableFilterRules () {
            this.tableFilterRules = {}
            this.tableHeaders.forEach(header => {
                this.tableFilterRules[header.value] = filterRulesMapped[header.filterType]
            })
        }
    },
    watch: {
        async selectedItem () {
            if (this.selectedItem) {
                this.queryId = this.selectedItem.id;
                await this.getData(true)
            }
        },
    }
}
